import { render, staticRenderFns } from "./channelText.vue?vue&type=template&id=e635629e&scoped=true"
import script from "./channelText.vue?vue&type=script&lang=js"
export * from "./channelText.vue?vue&type=script&lang=js"
import style0 from "./channelText.vue?vue&type=style&index=0&id=e635629e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e635629e",
  null
  
)

export default component.exports